import { render } from "./AASpecialSetting.vue?vue&type=template&id=096972e2&scoped=true"
import script from "./AASpecialSetting.vue?vue&type=script&lang=js"
export * from "./AASpecialSetting.vue?vue&type=script&lang=js"

import "./AASpecialSetting.vue?vue&type=style&index=0&id=096972e2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Management_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096972e2"]])

export default __exports__